import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
  SectionFilter,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class SentimentPolarityPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison,
      sectionFilter
    );

    const flattenedPoints = selectedPoints.flatMap((p) => p);
    for (let pointIdx = 0; pointIdx < flattenedPoints.length; pointIdx++) {
      const bucket = payload.buckets[pointIdx];
      const point = flattenedPoints[pointIdx];

      bucket.sentiment = point.series.name;
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);
    widgetQueryOptions.widgetContextMenu.series = {
      name: point.series.name,
    };
  }
}
